import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import {
  FileText,
  Settings,
  MapPin,
  ClipboardList,
  BookImage,
} from "lucide-react";

const UserDashBoard = () => {
  const navigate = useNavigate();
  const [DeletePopUp, setDeletePopUp] = useState(false);

  const OpenPopUp = () => {
    setDeletePopUp(true);
  };

  const ClosePopUp = () => {
    setDeletePopUp(false);
  };

  const ConfirmDelete = async () => {
    localStorage.clear();
    navigate("/");
    toast.success("Logout successfully");
  };

  const cards = [
    {
      id: 1,
      title: "My saved properties",
      description: "View open times and auctions for properties you’ve saved.",
      link: "/my-saved-property",
      icon: FileText,
      iconBg: "bg-gradient-to-r from-[#AD46FF] to-[#FB64B6]",
    },
    {
      id: 2,
      title: "Saved searches & alerts",
      description: "View your saved searches and configure their alerts.",
      link: "/SaveSearch",
      icon: MapPin,
      iconBg: "bg-gradient-to-r from-[#FF6900] to-[#FF6467]",
    },
    {
      id: 6,
      title: "Collections",
      description: "Create and manage your property collections.",
      link: "/collections",
      icon: BookImage,
      iconBg: "bg-gradient-to-r from-[#FF2056] to-[#FB64B6]",
    },
    // {
    //   id: 3,
    //   title: "Renter Profile",
    //   description: "Create or update your Renter Profile.",
    //   link: "/renter-profile",
    //   icon: House,
    //   iconBg: "bg-gradient-to-r from-[#00BC7D] to-[#00D5BE]",
    // },
    {
      id: 4,
      title: "Rental applications",
      description: "Track the status and view your rental applications.",
      link: "/rental-applications",
      icon: ClipboardList,
      iconBg: "bg-gradient-to-r from-[#615FFF] to-[#51A2FF]",
    },
    {
      id: 5,
      title: "Settings",
      description:
        "Manage your login details, notifications and privacy settings.",
      link: "/account-settings",
      icon: Settings,
      iconBg: "bg-gradient-to-r from-[#62748E] to-[#99A1AF]",
    },
    // {
    //   id: 6,
    //   title: "My rental listings",
    //   description: "Create and manage your rental property listings.",
    //   link: "/my-rental-listings",
    //   icon: FilePen,
    //   iconBg: "bg-gradient-to-r from-[#FF2056] to-[#FB64B6]",
    // },

  ];

  return (
    <>
      <div className="bg-[#F3F6F9] py-24 px-4 sm:px-6">
        <div className="container px-3 lg:px-20">
          <div className="rounded-2xl bg-[#097FE6] px-6 py-8 md:px-8 md:py-10 shadow-lg mb-8 relative">
            {/* <button
              type="button"
              onClick={OpenPopUp}
              className="absolute top-6 right-6 text-white/90 hover:text-white text-sm font-medium"
            >
              Log out
            </button> */}
            <h1 className="text-2xl md:text-3xl font-bold text-white">
              Welcome back! 👋
            </h1>
            <p className="text-white/95 text-sm md:text-base mt-2 max-w-xl">
              Explore your dashboard and manage all your property needs in one
              place.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {cards.map((item) => {
              const Icon = item.icon;
              return (
                <div
                  key={item.id}
                  onClick={() => navigate(item.link)}
                  className="group bg-white rounded-2xl p-6 border-[1.5px] border-[#EAEAEA] shadow-md hover:shadow-lg transition-all duration-200 cursor-pointer"
                >
                  <div
                    className={`w-14 h-14 rounded-xl flex items-center justify-center ${item.iconBg} shadow-[0px_4px_6px_-4px_#0000001A,0px_10px_15px_-3px_#0000001A]`}
                  >
                    <Icon className="w-7 h-7 text-white" strokeWidth={2} />
                  </div>
                  <h3 className="mt-8 text-xl font-medium text-[#000929]">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-base text-[#000929] opacity-75 leading-relaxed">
                    {item.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      {/* Modern Modal */}
      {DeletePopUp && (
        <>
          <div className="fixed inset-0 flex items-center justify-center z-[999999] backdrop-blur-sm bg-black/30">
            <div className="bg-white w-[90%] max-w-md rounded-3xl shadow-2xl p-8 animate-scaleIn">
              <div className="flex justify-end">
                <button
                  onClick={ClosePopUp}
                  className="text-gray-400 hover:text-gray-600 text-2xl"
                >
                  ×
                </button>
              </div>

              <div className="text-center">
                <h2 className="text-2xl font-bold text-gray-800">
                  Confirm Logout
                </h2>
                <p className="text-gray-500 mt-3 text-sm">
                  Are you sure you want to log out from your account?
                </p>
              </div>

              <div className="flex justify-center gap-4 mt-8">
                <button
                  onClick={ConfirmDelete}
                  className="px-6 py-2 rounded-full bg-[#097FE6] text-white font-medium hover:bg-[#097FE6] transition duration-300"
                >
                  Yes, Logout
                </button>

                <button
                  onClick={ClosePopUp}
                  className="px-6 py-2 rounded-full border border-gray-300 text-gray-600 hover:bg-gray-100 transition duration-300"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default UserDashBoard;
